package fr.frux.feature.site.detail

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.outlined.OpenInNew
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.semantics.Role
import fr.frux.core.designsystem.theme.FruxSpacing
import fr.frux.feature.site.resources.Res
import fr.frux.feature.site.resources.site_imported_angers
import fr.frux.feature.site.resources.site_imported_angers_license
import fr.frux.feature.site.resources.site_imported_cergy
import fr.frux.feature.site.resources.site_imported_cergy_license
import fr.frux.feature.site.resources.site_imported_la_rochelle
import fr.frux.feature.site.resources.site_imported_la_rochelle_license
import fr.frux.feature.site.resources.site_imported_osm
import fr.frux.feature.site.resources.site_imported_osm_license
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

/**
 * Origine d'un lieu importé en masse (ADR 0010, ADR 0037) : à la place du profil du compte
 * d'import, qui n'est personne, la source et sa licence. Même mécanique que `ImportSourceSection`
 * de la fiche arbre. Le tap ouvre la page du jeu de données, qui porte l'attribution due sur
 * toutes les plateformes.
 */
@Composable
internal fun SiteImportSourceSection(
    source: ImportedSiteSource,
    modifier: Modifier = Modifier,
) {
    val uriHandler = LocalUriHandler.current
    Row(
        modifier =
            modifier
                .fillMaxWidth()
                .clickable(role = Role.Button) { uriHandler.openUri(source.url) }
                .padding(vertical = FruxSpacing.sm),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
    ) {
        Column(modifier = Modifier.weight(1f)) {
            Text(
                text = stringResource(source.labelRes()),
                style = MaterialTheme.typography.bodyLarge,
            )
            Text(
                text = stringResource(source.licenseRes()),
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
        Icon(
            imageVector = Icons.AutoMirrored.Outlined.OpenInNew,
            contentDescription = null,
            tint = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }
}

/** Libellé d'en-tête « Importé de <source> », à la place de la ligne « Ajouté par ». */
internal fun ImportedSiteSource.labelRes(): StringResource =
    when (this) {
        ImportedSiteSource.OSM -> Res.string.site_imported_osm
        ImportedSiteSource.ANGERS -> Res.string.site_imported_angers
        ImportedSiteSource.CERGY -> Res.string.site_imported_cergy
        ImportedSiteSource.LA_ROCHELLE -> Res.string.site_imported_la_rochelle
    }

private fun ImportedSiteSource.licenseRes(): StringResource =
    when (this) {
        ImportedSiteSource.OSM -> Res.string.site_imported_osm_license
        ImportedSiteSource.ANGERS -> Res.string.site_imported_angers_license
        ImportedSiteSource.CERGY -> Res.string.site_imported_cergy_license
        ImportedSiteSource.LA_ROCHELLE -> Res.string.site_imported_la_rochelle_license
    }
